import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Welcome } from '../app/configure';
import { Workspaces } from '../app/workspaces';
import FloorView from '../app/workspaces/floor/layout';
import { NavigatorView } from '../app/workspaces/navigator/index';
import { ShowFrameRedirect } from '../app/configure/components/redirect-show-frame/index';
export const ROUTES = {
    WELCOME: '/',
    TENANT_PATH: '/t/:tm',
    SHOW_FRAME: '/showFrame',
    WORKSPACES: {
        HOME: 'home',
        BUILDING: 'building',
        FLOOR: 'floor',
        NAVIGATOR: 'navigator',
    },
};
export const mainRoutes = [
    {
        index: true,
        element: _jsx(Welcome, {}),
    },
    {
        path: ROUTES.TENANT_PATH,
        element: _jsx(Welcome, {}),
    },
    {
        path: ROUTES.SHOW_FRAME,
        element: _jsx(ShowFrameRedirect, {}),
    },
    {
        path: ROUTES.WORKSPACES.HOME,
        element: _jsx(Workspaces, {}),
    },
    {
        path: ROUTES.WORKSPACES.FLOOR,
        element: _jsx(FloorView, {}),
    },
    {
        path: ROUTES.WORKSPACES.NAVIGATOR,
        element: _jsx(NavigatorView, {}),
    },
];
